module.exports = __webpack_public_path__ + "static/media/lr.5485e606.svg";